<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18pXyZO/tc-custom/9781614230755.jpg?1724154588925" alt="This image is the cover for the book North Country Murder of Irene Izak"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">North Country Murder of Irene Izak
      </h1>
      <p class="bookDescription body article font2">
        <b>A road trip becomes a dead end for a schoolteacher in this haunting cold case of murder that became a fifty-year fight for justice.</b><br/>  <br/> In June of 1968, Irene Izak, a young French teacher from Scranton, Pennsylvania, was pulling an all-nighter on the road toward the promise of a new life in Quebec. The last time she was seen alive was at 2:09 a.m. by a toll collector at Thousand Island Bridge who claimed Irene was visibly afraid. Less than a half-hour later, Irene was found bludgeoned to death in a ravine bordering DeWolf Point State Park. There were no signs of robbery or sexual assault. For reasons unknown, Irene had been compelled to pull off the interstate and abandon her car, only to be brutally murdered.<br/>  <br/> Irene’s body was discovered by State Trooper Dave Hennigan, who’d stopped her for speeding shortly before—and issued the young woman a warning.<br/>  <br/> Blending novelistic suspense with true-crime reporting, author Dave Shampine investigates a crime that shook the communities of northeast Pennsylvania and New York's North Country—a vicious and confounding killing that has remained unsolved but not forgotten.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dave Shampine, Raymond O. Polett, Paul Ewasko, Lisa Caputo
      </h2>
      
      <p class="authorDescription body article">Dave Shampine, a lifelong resident of Jefferson County, New York, has been a reporter for the Watertown Daily Times since 1971, with the majority of his career focused on crime reporting. He has written his history column, Times Gone By, "? for the past twelve years and is also a contributing writer and copyeditor for the Bulletin of the Jefferson County Historical Society in Watertown. He is the author of Remembering New York's North County: Tales from Times Gone By and Colorful Characters of Northern New York: Northern Lights, both published by The History Press. He has received awards from the New York State Bar Association, New York Newspaper Publishers Association, New York State Associated Press Association and the Jefferson Community College Alumni Association, which honored him with a professional achievement award."</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?169cb248